module.exports = __webpack_public_path__ + "static/nashville-2234878d3c19ae9315d111b531b780e5.png";